import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';

import LocalizedPlainStringField from 'yeself-client-common/form/components/LocalizedPlainStringField';

import {
    selectContextHelpContent,
    selectFallbackLanguage,
} from 'Console/data/applicationDetail/settings/SettingsSelector';

import { selectContentLanguage } from 'Console/data/language/selectors';

const ViewPlaylistsField = ({ classes, form: { getFieldDecorator } }): React.ReactElement => {
    const intl = useIntl();
    const { formatMessage } = intl;

    const contentLanguage = useSelector(selectContentLanguage);
    const fallbackLanguage = useSelector(selectFallbackLanguage);
    const content = useSelector(selectContextHelpContent);

    return (
        <Grid container className={classes.itemsBox}>
            <Grid item xs={12}>
                <Typography variant="subtitle1" className={classes.title}>
                    <FormattedMessage id="ContextHelp.playlists" defaultMessage="Playlists" />
                </Typography>
            </Grid>
            <Grid container direction="row" alignItems="center" style={{ paddingBottom: '20px' }}>
                <Typography variant="body1" className={classes.formName}>
                    <FormattedMessage id="ContextHelp.playlists.label" defaultMessage="Button text" />
                </Typography>

                <Grid className={classes.formInput}>
                    {getFieldDecorator('contextHelp.viewPlaylistsText', {
                        initialValue: content.viewPlaylistsText,
                        preserve: true,
                    })(
                        <LocalizedPlainStringField
                            locale={contentLanguage}
                            fallbackLocale={fallbackLanguage.value}
                            placeholder={formatMessage({
                                id: 'ContextHelp.playlists.placeholder',
                                defaultMessage: 'View Playlists',
                            })}
                        />
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ViewPlaylistsField;
